import ImportForm from './importForm.container';

export default ImportForm;
